// /enter-school-code?mode=required|add (feature 003; P-JOIN-8, P-AUTH-2).
import { EnterSchoolCodeScreen } from "@/join/EnterSchoolCodeScreen";

export default function EnterSchoolCode() {
  return <EnterSchoolCodeScreen />;
}
